import React from 'react';
import { pdf } from '@react-pdf/renderer';
import { ResumePDFDocument } from './ResumePDFDocument.jsx';

/**
 * Generates a PDF Blob entirely on the client side using @react-pdf/renderer.
 * @param {Object} formData 
 * @param {string} template 
 * @param {Object} sectionsEnabled 
 * @returns {Promise<Blob>}
 */
export const generatePdfBlob = async (formData, template = 'modern', sectionsEnabled = {}) => {
  try {
    const doc = <ResumePDFDocument formData={formData} template={template} sectionsEnabled={sectionsEnabled} />;
    const asPdf = pdf([]);
    asPdf.updateContainer(doc);
    return await asPdf.toBlob();
  } catch (err) {
    console.error('generatePdfBlob error:', err);
    throw err;
  }
};

export const downloadResumePDF = async (formData, template = 'modern', sectionsEnabled = {}) => {
  const blob = await generatePdfBlob(formData, template, sectionsEnabled);
  
  const safeName = (formData?.personal?.name || 'Resume').trim().replace(/\s+/g, '_');
  const fileName = `QA_Resume_${safeName}.pdf`;

  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url; 
  a.download = fileName;
  document.body.appendChild(a); 
  a.click();
  document.body.removeChild(a); 
  URL.revokeObjectURL(url);
};

export const previewResumePDF = async (formData, template = 'modern', sectionsEnabled = {}) => {
  // Open window synchronously to avoid popup blockers
  const newWindow = window.open('', '_blank');
  if (newWindow) {
    newWindow.document.write('<html><body style="font-family:sans-serif;padding:2rem;">Generating your PDF preview... Please wait.</body></html>');
  }

  try {
    const blob = await generatePdfBlob(formData, template, sectionsEnabled);
    const url = URL.createObjectURL(blob);
    
    if (newWindow) {
      newWindow.location.href = url;
    } else {
      // If popup was blocked, fallback to same window
      window.location.href = url;
    }
  } catch (error) {
    console.error('previewResumePDF error:', error);
    if (newWindow) newWindow.close();
    throw error;
  }
};
